<template>
   <v-dialog 
      v-model="show" 
      @close="$emit('close')"
      @click:outside="$emit('close')"
      :max-width="maxWidth"
      :scrollable="scrollable"
    >
      <v-card
        v-if="show"
        class="pb-1 px-6"
      >
        <!-- 
          Custom header layout
        -->
        <v-card-title 
          v-if="$slots.header"
        >
           <slot name="header" />
        </v-card-title>
        <!-- 
          Default header layout
        -->
        <v-card-title 
          v-else-if="$slots.title || $slots['header-actions'] || showCloseIcon"
          class="action-bar d-flex align-center justify-space-between pb-4 px-0"
          style="border-bottom: 1px solid #E0E0E0;"
        >
          <!-- Title -->
          <div v-if="$slots.title" 
            class="text-h5 font-weight-bold"
            style="color: #424242 !important; "
          >
            <slot name="title" /> 
          </div>
          <!-- Header actions -->
          <div v-if="$slots['header-actions'] || showCloseIcon" class="d-flex align-center flex-grow-1">
            <div v-if="$slots['header-actions']">
              <slot name="header-actions" />
            </div>
            <!-- Default close action -->
            <div 
              v-if="showCloseIcon"
              class="d-none d-md-flex flex-grow-1 justify-end"
            >
              <Button 
                :icon="closeIcon"
                size="small"
                color="grey"
                @click="$emit('close')"
              />
            </div>
          </div>
        </v-card-title>
        <!--
          Dialog body 
        -->
        <slot />
        <v-card-text 
          v-if="$slots.body"
          class=""
        >
          <slot name="body" />
        </v-card-text>
        <!--
          Custom footer layout
        -->
        <v-card-actions v-if="$slots.footer">
          <slot name="footer" />
        </v-card-actions>
        <!--
          Default footer layout
        -->
        <v-card-actions 
          v-else-if="$slots['footer-actions'] || showCloseButton"
          class="pt-3 px-0"
          style="border-top: 1px solid #E0E0E0;"
        >
          <div class="d-flex justify-end" style="width: 100%;">
            <!-- Footer actions -->
            <slot name="footer-actions" />
            <!-- Default close action -->
            <Button 
              v-if="showCloseButton"
              :prepend-icon="closeIcon"
              color="grey"
              @click="$emit('close')"
            >
              {{ closeButtonText }}
            </Button>
          </div>
        </v-card-actions>
      </v-card>
   </v-dialog>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  name: 'Dialog',
  components: {
    Button,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    closeIcon: {
      type: String,
      default: 'mdi-close',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    closeButtonText: {
      type: String,
      default: 'Cerrar',
    },
    maxWidth: {
      type: String,
      default: '1000px',
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
  }
}
</script>

<style scoped>
</style>